import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";

export default function FooterMP() {
  return (
    <Box borderTopWidth={1} borderStyle={"solid"} borderColor={"gray.300"}>
      <Flex
        w={"100%"}
        data-testid="footer"
        // as={Stack}
        px={4}
        direction={{ base: "column", md: "row" }}
        justify={{ md: "space-between" }}
        align={{ md: "center" }}
      >
        <Flex>
          <Text>© MCA - Módulo da Criança e do Adolescente.</Text>
        </Flex>
        <Flex>
          <Text>Versão 2.45.0</Text>
        </Flex>
      </Flex>
    </Box>
  );
}
